import { render, staticRenderFns } from "./organauthstart.vue?vue&type=template&id=2cc5f330&scoped=true"
import script from "./organauthstart.vue?vue&type=script&lang=js"
export * from "./organauthstart.vue?vue&type=script&lang=js"
import style0 from "./organauthstart.vue?vue&type=style&index=0&id=2cc5f330&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc5f330",
  null
  
)

export default component.exports